<div class="container">

    <div class="row d-flex justify-content-center">
        <div class="col-md-12">
            <h4 class="text-primary">{{ data.TITLE }}</h4>
        </div>
    </div>

    <div class="row d-flex justify-content-center">
        <div class="col-md-12">
            <hr>
        </div>
    </div>

    <form [formGroup]="formGroup">

        <div class="row d-flex justify-content-center">

            <div class="col-md-12">

                <div class="row">
                    <div class="col-md-12">
                        <div class="control-group">
                            <div class="form-group mb-0 pb-2">
                                <label class="control-label">{{ data.CAMPO_NOME }} <span
                                        class="text-danger">*</span></label>
                                <input class="form-control form-control-sm" type="text" formControlName="formNome"
                                    (mouseleave)="validaForm()" (keyup)="validaForm()">

                                <!-- Mensagens de erro -->
                                <div *ngFor="let validator of data.VALIDATOR.NOME">
                                    <span class="text-danger"
                                        *ngIf="formGroup.get('formNome').hasError(validator.TYPE) && (formGroup.get('formNome').dirty || formGroup.get('formNome').touched) ">{{
                                        validator.MENSAGEM }}</span>
                                </div>
                                <!-- Mensagens de erro -->

                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">

                    <div class="col-md-8">
                        <div class="control-group">
                            <div class="form-group mb-0 pb-2">
                                <label class="control-label">{{ data.CAMPO_EMAIL }} <span
                                        class="text-danger">*</span></label>
                                <input class="form-control form-control-sm" type="email" formControlName="formEmail"
                                    (mouseleave)="validaForm()" (keyup)="validaForm()">

                                <!-- Mensagens de erro -->
                                <div *ngFor="let validator of data.VALIDATOR.EMAIL">
                                    <span class="text-danger"
                                        *ngIf="formGroup.get('formEmail').hasError(validator.TYPE) && (formGroup.get('formEmail').dirty || formGroup.get('formEmail').touched) ">{{
                                        validator.MENSAGEM }}</span>
                                </div>
                                <!-- Mensagens de erro -->

                            </div>
                        </div>
                    </div>

                    <div class="col-md-4">
                        <div class="control-group">
                            <div class="form-group mb-0 pb-2">
                                <label class="control-label">{{ data.CAMPO_TELEFONE }}</label>
                                <input class="form-control form-control-sm" type="text" formControlName="formTelefone"
                                    (mouseleave)="validaForm()" (keyup)="validaForm()" maxlength="18">

                                <!--  mask="(99) 99999-9999" -->

                                <!-- Mensagens de erro -->
                                <div *ngFor="let validator of data.VALIDATOR.TELEFONE">
                                    <span class="text-danger"
                                        *ngIf="formGroup.get('formTelefone').hasError(validator.TYPE) && (formGroup.get('formTelefone').dirty || formGroup.get('formTelefone').touched) ">{{
                                        validator.MENSAGEM }}</span>
                                </div>
                                <!-- Mensagens de erro -->

                            </div>
                        </div>
                    </div>

                </div>

                <div class="row">

                    <div class="col-md-8">
                        <div class="control-group">
                            <div class="form-group mb-0 pb-2">
                                <label class="control-label">{{ data.CAMPO_EMPRESA }}</label>
                                <input class="form-control form-control-sm" type="email"
                                    formControlName="formNomeEmpresa" (mouseleave)="validaForm()"
                                    (keyup)="validaForm()">

                                <!-- Mensagens de erro -->
                                <div *ngFor="let validator of data.VALIDATOR.NOME_EMPRESA">
                                    <span class="text-danger"
                                        *ngIf="formGroup.get('formNomeEmpresa').hasError(validator.TYPE) && (formGroup.get('formNomeEmpresa').dirty || formGroup.get('formNomeEmpresa').touched) ">{{
                                        validator.MENSAGEM }}</span>
                                </div>
                                <!-- Mensagens de erro -->

                            </div>
                        </div>
                    </div>

                    <div class="col-md-4">
                        <div class="control-group">
                            <div class="form-group mb-0 pb-2">
                                <label class="control-label">{{ data.CAMPO_CARGO }}</label>
                                <input class="form-control form-control-sm" type="email" formControlName="formCargo"
                                    (mouseleave)="validaForm()" (keyup)="validaForm()">

                                <!-- Mensagens de erro -->
                                <div *ngFor="let validator of data.VALIDATOR.CARGO">
                                    <span class="text-danger"
                                        *ngIf="formGroup.get('formCargo').hasError(validator.TYPE) && (formGroup.get('formCargo').dirty || formGroup.get('formCargo').touched) ">{{
                                        validator.MENSAGEM }}</span>
                                </div>
                                <!-- Mensagens de erro -->

                            </div>
                        </div>
                    </div>

                </div>

                <div class="row mt-2">
                    <div class="col-md-12">
                        <p>{{ data.DESCRICAO }}</p>
                    </div>
                </div>

            </div>

        </div>

    </form>

</div>